module.exports = __webpack_public_path__ + "img/postes.77328583.svg";